'use client';

import { createContext, useCallback, useContext } from 'react';
import { useRouter } from 'next/navigation';

type ConsultationContextProps = {
  // Leva ao formulário de marcação (/marcar-consulta). `storeSlug` deixa a
  // loja já escolhida (ex.: a partir da página de uma loja).
  openModal: (storeSlug?: string) => void;
};

export const ConsultationContext = createContext<ConsultationContextProps>({
  openModal: () => {},
});

/**
 * Antes, "Marcar consulta" abria uma janela por cima da página; agora o
 * formulário é a página /marcar-consulta, em 4 passos — os botões do site
 * continuam a chamar `openModal`, que passou a navegar para lá.
 */
export const ConsultationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const router = useRouter();

  const openModal = useCallback(
    (storeSlug?: string) => {
      router.push(
        storeSlug
          ? `/marcar-consulta?loja=${encodeURIComponent(storeSlug)}`
          : '/marcar-consulta',
      );
    },
    [router],
  );

  return (
    <ConsultationContext.Provider value={{ openModal }}>
      {children}
    </ConsultationContext.Provider>
  );
};

export const useConsultation = () => useContext(ConsultationContext);
